import type { ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'sm' | 'md';

type Props = LinkProps & {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
};

const VARIANTS: Record<Variant, string> = {
  primary: 'text-white shadow-sm hover:opacity-95',
  secondary: 'bg-white border border-slate-200 text-slate-800 hover:bg-slate-50',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100',
};

const SIZES: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-sm rounded-md',
  md: 'px-4 py-2 text-sm rounded-lg',
};

export function LinkBtn({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  style,
  ...rest
}: Props) {
  const variantStyle =
    variant === 'primary' ? { backgroundColor: 'var(--brand-primary)', ...style } : style;
  return (
    <Link
      className={`inline-flex items-center justify-center gap-2 font-medium transition no-underline ${SIZES[size]} ${VARIANTS[variant]} ${className}`}
      style={variantStyle}
      {...rest}
    >
      {children}
    </Link>
  );
}
